module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-3-small-93061bf02c53acafd2f56825a8d4da1c.jpg";